import React, { Fragment } from 'react';
import Helpers from '@Apis/helpers';
import { entityNameEnum } from '@Apis/constants';
import H3Text from '../../../../../uilib/h3Text';
import constants from '../../../../../apis/constants';

const getLinkedDocumentInfo = ({
  selectedGRN,
  user,
  priceMasking,
  showViewPayout,
  setState,
}) => {
  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const linkedDocumentsInfo = [];

  if (selectedGRN?.debit_notes?.length && Helpers.getPermission(Helpers.permissionEntities.DEBIT_NOTE, Helpers.permissionTypes.READ, user)) {
    const documentDataInfo = selectedGRN?.debit_notes?.map((item) => ({
      documentId: item?.dn_id,
      documentNumber: item?.debit_note_number,
      documentStatus: item?.status,
      documentTotal: item?.document_dn_grand_total || item?.dn_grand_total,
    }));

    linkedDocumentsInfo.push({
      entityName: entityNameEnum.DEBIT_NOTE,
      title: 'ASSOCIATED DEBIT NOTES',
      entityNumberPrefix: 'DN',
      documentData: documentDataInfo,
      isRedirect: true,
      redirectPath: '/purchase/debit-note/view/',
      popOverMessage: 'You don\'t have access to view amount',
      hidePrice: isDataMaskingPolicyEnable && isHideCostPrice,
      entityVisible: documentDataInfo.length > 0,
      showEntityTotal: true,
    });
  }

  if (!(isDataMaskingPolicyEnable && (isHideCostPrice || isHideSellingPrice)) && selectedGRN?.grn_payments?.length) {
    const documentDataInfo = selectedGRN?.grn_payments?.map((item) => ({
      ...item,
      documentId: item?.payment_id,
      documentNumber: `${item?.applied_payment_type?.split('_')?.map((word) => word?.[0].toUpperCase())?.join('')} # ${item?.debit_note_number || item?.payment_id}`,
      documentStatus: item?.status,
      documentTotal: item?.amount,
    }));

    linkedDocumentsInfo.push({
      entityName: entityNameEnum.OUTGOING_PAYMENTS,
      title: 'LINKED PAYMENTS',
      entityNumberPrefix: '',
      documentData: documentDataInfo,
      isDrawer: true,
      drawerState: showViewPayout,
      drawerCallback: (payment, isOpen) => {
        setState({ selectedPayment: payment, showViewPayout: isOpen });
      },
      entityVisible: documentDataInfo.length > 0,
      showEntityTotal: true,
    });
  }

  if (selectedGRN?.ap_invoices?.length) {
    const documentDataInfo = selectedGRN?.ap_invoices?.map((item) => ({
      documentId: item?.ap_invoice_id,
      documentNumber: item?.ap_invoice_number,
      documentStatus: item?.status,
      documentTotal: item?.grand_total,
    }));

    linkedDocumentsInfo.push({
      entityName: entityNameEnum.ACCOUNT_PAYABLE_INVOICE,
      title: 'LINKED AP INVOICES',
      entityNumberPrefix: '',
      documentData: documentDataInfo,
      isRedirect: true,
      redirectPath: '/purchase/account-payable-invoice/view/',
      hidePrice: isDataMaskingPolicyEnable && isHideCostPrice,
      entityVisible: documentDataInfo.length > 0,
      showEntityTotal: true,
    });
  }

  return linkedDocumentsInfo;
};

const handleFileChange = ({
  fileListData, selectedGRN, updateAttachment, getAttachmentById, setState,
}) => {
  const fileList = fileListData?.fileList?.map((item) => ({
    ...item,
    url: item?.response?.response?.location || item?.url,
  }));
  const attachments = fileList?.map((attachment) => ({
    url: attachment?.response?.response?.location || attachment?.url, type: attachment.type, name: attachment.name, uid: attachment.uid,
  }));
  if (fileListData?.file.status === 'done') {
    const payload = {
      entity_id: selectedGRN?.grn_id,
      entity_name: 'good_receiving_note',
      attachments,
    };
    updateAttachment(payload, () => {
      getAttachmentById(selectedGRN?.grn_id, 'good_receiving_note', () => {
        setState({
          isGetAttachment: true,
        });
      });
    });
  }
  if (fileListData?.file.status === 'removed') {
    const payload = {
      entity_id: selectedGRN?.grn_id,
      entity_name: 'good_receiving_note',
      attachments,
    };
    updateAttachment(payload, () => {
      getAttachmentById(selectedGRN?.grn_id, 'good_receiving_note', () => {
        setState({
          isGetAttachment: true,
        });
      });
    });
  }

  setState({
    fileList: attachments.length > 0 ? attachments : [],
  });
};

const renderFreight = ({
  position, selectedGRN, MONEY, user,
}) => {
  const isVendorOverseas = selectedGRN?.seller_info?.seller_type === 'OVERSEAS' && user?.tenant_info?.purchase_config?.sub_modules?.vendor?.settings?.hide_tax_for_overseas;
  if ((selectedGRN?.charge_1_value > 0)) {
    if (position === 'top' && selectedGRN?.freight_tax_id) {
      return (
        <div className="view-document__totals-field">
          <H3Text
            text={(
              <Fragment>
                {selectedGRN?.charge_1_name}
                &nbsp;
                {!isVendorOverseas && (<span className="table-subscript">{`tax@${selectedGRN?.freight_tax_info?.tax_value}%`}</span>)}
              </Fragment>
            )}
            className="view-document__totals-field-name"
          />
          <H3Text text={MONEY((selectedGRN?.charge_1_value), selectedGRN?.org_currency_info?.currency_code)} className="view-document__totals-field-value" />
        </div>
      );
    }
    if (position === 'bottom' && !selectedGRN?.freight_tax_id) {
      return (
        <div className="view-document__totals-field">
          <H3Text text={selectedGRN?.charge_1_name} className="view-document__totals-field-name" />
          <H3Text text={MONEY((selectedGRN?.charge_1_value), selectedGRN?.org_currency_info?.currency_code)} className="view-document__totals-field-value" />
        </div>
      );
    }
  }
  return '';
};

const renderCharges = ({
  charge, selectedGRN, user, MONEY,
}) => {
  const isVendorOverseas = (selectedGRN?.seller_info?.seller_type === 'OVERSEAS' || selectedGRN?.seller_type === 'OVERSEAS') && user?.tenant_info?.purchase_config?.sub_modules?.vendor?.settings?.hide_tax_for_overseas;

  return !!charge?.length && charge?.map((otherCharge, i) => (
    <div key={i} className="view-document__totals-field">
      <H3Text
        text={(
          <Fragment>
            {otherCharge?.charge_name?.toProperCase()}
            &nbsp;
            {otherCharge?.tax_info?.tax_value && !isVendorOverseas ? (
              <span className="table-subscript">{`tax@${otherCharge.tax_info.tax_value}%`}</span>
            ) : null}
          </Fragment>
        )}
        className="view-document__totals-field-name"
      />
      <H3Text text={MONEY((otherCharge?.charge_amount), selectedGRN?.org_currency_info?.currency_code)} className="view-document__totals-field-value" />
    </div>
  ));
};

const getQcData = ({ data, selectedGRN }) => {
  const requiredData = [];
  const productBatches = data?.map((item) => item?.product_batches)?.flat(1);
  const qualityChecks = productBatches?.map((productBatch) => productBatch?.quality_checks)?.flat(1);
  const qualityChecksArr = [];
  qualityChecks?.map((qualityCheck) => {
    data?.map((grnLine) => {
      if (qualityCheck?.entity_line_id === grnLine?.grn_line_id) {
        qualityChecksArr.push({
          ...qualityCheck,
          ordered_qty: grnLine?.ordered_qty,
          product_sku_info: grnLine?.product_sku_info,
          tenant_product_id: grnLine?.tenant_product_id,
          expiry_date: grnLine?.expiry_date,
          available_batches: grnLine?.available_batches,
          tax_info: grnLine?.tax_info,
          uom_info: grnLine?.uom_info,
          uom_list: grnLine?.product_sku_info?.uom_list,
          tenant_department_id: selectedGRN?.tenant_department_id,
        });
      }
    });
  });
  qualityChecksArr?.map((qualityCheck) => {
    productBatches?.map((productBatch) => {
      if (productBatch?.batch_id === qualityCheck?.batch_id) {
        requiredData.push({
          ...qualityCheck,
          custom_batch_number: productBatch?.custom_batch_number,
          lot_number: productBatch?.lot_number,
          batch_number: productBatch?.batch_number,
          mrp: productBatch?.mrp,
          cost_price: productBatch?.cost_price,
          inventory_location_id: productBatch?.inventory_location_id,
          inventory_location_name: productBatch?.inventory_location_name,
          inventory_location_path: productBatch?.inventory_location_path,
          is_rejected_batch: productBatch?.is_rejected_batch,
          selling_price: productBatch?.selling_price,
          expiry_date: productBatch?.expiry_date,
          quantity: productBatch?.quantity,
        });
      }
    });
  });
  return requiredData;
};

const splitChargesData = (charge) => {
  const chargeWithTaxName = charge?.filter((line) => line?.tax_info?.tax_id) || [];
  const chargeWithoutTaxName = charge?.filter((line) => !line?.tax_info?.tax_id) || [];
  return { chargeWithTaxName, chargeWithoutTaxName };
};

const handleFileChangeEWayBill = ({ event, setState }) => {
  const file = event.target.files[0];
  if (file) {
    const formData = new FormData();
    formData.append('file', file);

    fetch(constants.UPLOAD_FILE, {
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        setState({ eWayBillAttachment: data });
      })
      .catch((error) => {
        console.error('Error uploading file:', error);
      });
  }
};
export {
  getLinkedDocumentInfo,
  handleFileChange,
  renderFreight,
  renderCharges,
  getQcData,
  splitChargesData,
  handleFileChangeEWayBill,
};
